var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app_detail_tab7"
  }, [_c('div', {
    staticClass: "apt_item"
  }, [_c('div', [_vm._v($t("mdsf9hp", "员工iWork 办理入职，自动创建或关联子应用账号"))]), _c('i-switch', {
    attrs: {
      "size": "large",
      "loading": _vm.loading,
      "true-value": "T",
      "false-value": "F"
    },
    on: {
      "on-change": _vm.changeConfigPer
    },
    model: {
      value: _vm.form.permitsCreateOrUpdate,
      callback: function ($$v) {
        _vm.$set(_vm.form, "permitsCreateOrUpdate", $$v);
      },
      expression: "form.permitsCreateOrUpdate"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v($t("gmcv2", "开启"))]), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v($t("eod62", "关闭"))])])], 1), _c('div', {
    staticClass: "apt_item"
  }, [_c('div', [_vm._v($t("3yom8bm", "员工iWork 办理离职，自动停用子应用账号"))]), _c('i-switch', {
    attrs: {
      "size": "large",
      "loading": _vm.loading,
      "true-value": "T",
      "false-value": "F"
    },
    on: {
      "on-change": _vm.changeConfig
    },
    model: {
      value: _vm.form.permitsHalt,
      callback: function ($$v) {
        _vm.$set(_vm.form, "permitsHalt", $$v);
      },
      expression: "form.permitsHalt"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v($t("gmcv2", "开启"))]), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v($t("eod62", "关闭"))])])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };